class RecipeScroll extends HTMLElement {
  constructor() {
    super();

    this.target = "";

    this.addListener();
  }

  addListener() {
    const button = this.querySelector(".js-to-recipe");
    const tabRecipe = document.querySelector(".tabs--recipe");
    const articleRecipe = document.querySelector(".article__recipe");

    button.addEventListener("click", () => {
      const header = document.querySelector(".header").offsetHeight;
      const offset = document.documentElement.scrollTop;

      if (tabRecipe) {
        this.target = tabRecipe.getBoundingClientRect().top;

        if (!tabRecipe.classList.contains("aos-animate")) this.target -= 100;
      }
      else if (articleRecipe) this.target = articleRecipe.getBoundingClientRect().top;

      const y = this.target + offset - header;

      window.scrollTo({ top: y, behavior: "smooth" })
    });
  }
}

customElements.define("recipe-scroll", RecipeScroll);